"use strict";
/**
 * @file Created on Fri Mar 22 2019
 * @author Tomáš Leity
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");
/**
 * Validator that checkes number's an positive integer
 */


var IntegerPositiveValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(IntegerPositiveValidator, _Validator_1$Validato);

  function IntegerPositiveValidator() {
    var _this;

    var zero = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var errorMessage = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, IntegerPositiveValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IntegerPositiveValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.zero = zero;
    _this.errorMessage = errorMessage;
    return _this;
  }

  _createClass(IntegerPositiveValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      var sign = Math.sign(value);

      if (Number.isNaN(sign) || (this.zero ? sign < 0 || Object.is(sign, -0) : sign <= 0) || !Number.isInteger(value)) {
        return new ValidationResult_1.ValidationError(this.errorMessage || IntegerPositiveValidator.NOT_POSITIVE_INTEGER_ERROR, value);
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return IntegerPositiveValidator;
}(Validator_1.Validator);

exports.IntegerPositiveValidator = IntegerPositiveValidator;
IntegerPositiveValidator.NOT_POSITIVE_INTEGER_ERROR = 'NOT_POSITIVE_INTEGER';